<template>
  <div
    class="video-item"
    @click="videoPlay(videoItem.id)">
    <div class="video-img-content">
      <div
        class="video-img"
        :style="{backgroundImage: 'url(' + videoItem.videos[0].image + ')'}"/>
      <div
        class="play-icon"
        v-if="(!videoShow) || (!isAndroid&&isUc)"/>
    </div>
    <div class="bottom-text">{{ videoItem.title }}
      <div class="look-count">{{ videoItem.medium.name }} {{ viewCount(videoItem) }}万次观看</div>
    </div>

  </div>
</template>

<script>
import Bus from '../common/js/bus.js';
import { fetchList, postLog } from '../common/js/fetch.js';
// import urlencode from 'urlencode'

export default {
  data() {
    return {
      videoShow: false,
      videoShowLoad: false,
      imgShow: true,
      isPlay: false,
    };
  },

  props: {
    videoItem: {
      type: Object,
      default: function() {
        return {};
      },
    },
    isAndroid: {
      type: Boolean,
      default: true,
    },
    isUc: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    viewCount(videoItem) {
      const count =
        videoItem.videos[0].viewCnt < 10000
          ? 1
          : Math.ceil(videoItem.videos[0].viewCnt / 10000);
      return count;
    },

    logPlay() {
      const play = {
        transparent: this.videoItem.transparent,
        subType: 'startPlay',
        docid: this.videoItem.id,
        date: this.getDate(),
        position: 'list',
        playType: 0,
      };
      const obj = {
        feedssession: this.$parent.getCookie('c_session_id')
          ? this.$parent.getCookie('c_session_id')
          : null,
        subType: 'startPlay',
        log: JSON.stringify(play),
        session: this.$parent.getCookie('c_session')
          ? this.$parent.getCookie('c_session')
          : null,
      };

      // let url = window.oppo.COMMON.videoBaseUri + 'videoLog/log?' + urlencode.stringify(obj, {charset: 'gbk'})

      // const img = new Image()
      // img.src = url
    },

    logPlayTime() {
      const play = {
        transparent: this.videoItem.transparent,
        subType: 'play',
        timeElapsed: 276,
        docid: this.videoItem.id,
        date: this.getDate(),
        actionSrc: 'newsListView',
        position: 'list',
        percent: 80,
      };
      const obj = {
        feedssession: this.$parent.getCookie('c_session_id')
          ? this.$parent.getCookie('c_session_id')
          : null,
        subType: 'play',
        log: JSON.stringify(play),
        session: this.$parent.getCookie('c_session')
          ? this.$parent.getCookie('c_session')
          : null,
      };

      // let url = window.oppo.COMMON.videoBaseUri + 'videoLog/log?' + urlencode.stringify(obj, {charset: 'gbk'})

      // const img = new Image()
      // img.src = url
    },

    videoPlay(id) {
      window.oa('send', {
        hitType: 'event',
        eventCategory: 'video_btn',
        eventAction: 'click',
        eventLabel: '/home',
        eventValue: id,
      });
      this.$router.push({
        path: 'detail',
        query: {
          id: this.videoItem.id,
          source: this.videoItem.source,
          mediaNo: this.videoItem.medium.mediaNo
        },
      });
    },

    loadVideo() {
      if (this.isPlay) {
        return;
      }
      this.isPlay = true;
      this.videoShowLoad = false;
      if (this.videoShow) {
        this.imgShow = false;
      }
    },

    getDate() {
      const myDate = new Date();
      const Year = this.number(myDate.getFullYear());
      const Month = this.number(myDate.getMonth());
      const Day = this.number(myDate.getDate());
      const H = this.number(myDate.getHours());
      const M = this.number(myDate.getMinutes());
      const S = this.number(myDate.getSeconds());

      return `${Year}-${Month}-${Day} ${H}:${M}:${S}`;
    },

    number(num) {
      if (num < 10) {
        return '0' + num;
      }
      return num;
    },
  },

  mounted() {
    Bus.$on('paused', message => {
      this.videoShow = false;
      this.videoShowLoad = false;
      this.imgShow = true;
      this.$refs.video.pause();
      // this.isPlay = false
    });
  },
};
</script>
<style lang='scss' scoped>
.look-count {
  font-size: px2rem(33);
  color: #b2b2b2;
  padding-bottom: px2rem(40);
  padding-top: px2rem(8);
}
.video-item {
  position: relative;
  box-sizing: border-box;
  min-height: px2rem(784);
  box-shadow: 0 px2rem(10) 0 0 #e3e3e3;
  margin-bottom: px2rem(10);
  video {
    width: 100%;
    height: px2rem(612);
  }
  .video-content {
    position: relative;
    width: 100%;
    height: px2rem(612);
    overflow: hidden;
  }
  .video-img-content {
    width: 100%;
    min-height: px2rem(612);
    position: relative;
    // top: 0;
    // left: 0;
  }
  .video-img {
    width: 100%;
    min-height: px2rem(612);
    position: relative;
    overflow: hidden;

    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    z-index: 1000;
  }
  .video-img::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.05);
  }
  .play-icon {
    background: url('../common/img/Group.png') no-repeat 0 0 / px2rem(112)
      px2rem(112);
    width: px2rem(112);
    height: px2rem(112);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1001;
  }
  .play-icon-load {
    background: url('../common/img/loading.gif') no-repeat 0 0 / px2rem(112)
      px2rem(112);
    width: px2rem(112);
    height: px2rem(112);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1001;
  }
  .title {
    color: #fff;
    font-size: px2rem(34);
    position: absolute;
    display: inline-block;
    max-width: px2rem(864);
    position: absolute;
    right: px2rem(46);
    bottom: px2rem(46);
    // letter-spacing: 1px;
    z-index: 1001;
    background: rgba(0, 0, 0, 0.6);
    border-radius: px2rem(50);
    padding: px2rem(2) px2rem(30);
  }
  .title-box {
    z-index: 1001;
    position: relative;
    // bottom: 0;
    // left: 0;
    text-align: right;
    width: 100%;
    height: px2rem(148);
    // background: linear-gradient(
    //   to bottom,
    //   transparent,
    //   rgba(0, 0, 0, 0.3) 72%,
    //   rgba(0, 0, 0, 0.6)
    // );
  }
  .bottom-text {
    font-size: px2rem(48);
    color: #000;
    margin: px2rem(30) px2rem(54) px2rem(10);
    position: relative;
    // top: px2rem(612);
    // left: 0;
    font-weight: 700;
    letter-spacing: 0.16px;
    div {
      font-weight: 500;
    }
  }
}
</style>
